module.exports = __webpack_public_path__ + "img/loading.21cf5789.svg";